import { useEffect, useState } from 'react';

/** Counts down from the set number of seconds and lands at null once it reaches 0.
 *
 * @returns [seconds, setSeconds] number of seconds on the timer or null if reached 0, and function to set
 * the number of seconds on the timer.
 */
export const useTimer = () => {
  const [seconds, setSeconds] = useState<number | null>(null);

  useEffect(() => {
    const timer = setInterval(() => {
      if (seconds === null || seconds <= 1) {
        setSeconds(null);
        clearInterval(timer);
        return;
      }
      setSeconds(seconds - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  return [seconds, setSeconds] as const;
};
